


function Footer() {
  const year = new Date().getFullYear();
  return (

    <div className="container-fluid bg-dark text-light pt-4" id="footer">
      
        <div className="row">
          <div className="col-12">
            <h5><a className="navbar-brand" href="https://www.AccessEVA.ai/">
              <span className="mt-1"
                style={{ color: "gray", fontWeight: 500 }}>AccessEVA.ai</span>
            </a></h5>
            <p></p>
          </div>
          <div className="">
            <hr className="mb-1" />
            <p className="note">&copy; {year}  AccessEVA LLC. All rights reserved. | <a href="../../legal/privacyPolicy.html" target="_blank">Privacy Policy</a> | <a href="../../legal/termsOfService.html" target="_blank">Terms of Service</a></p>
          </div>
        </div>
      
    </div>

  );
}

export default Footer;
